import React, { useMemo, useState } from "react";
import Button from "@mui/material/Button";
import { Card, CardContent, CardHeader, Grid } from "@mui/material";

import { useDispatch, useSelector } from "react-redux";
import EmailAddressTRN from "../Helpers/UserComponents/EmailComponent";
import createDecorator from "final-form-calculate";

import {
  NameField,
  SurnameField,
  IDNumberComponent,
  PassportComponent,
  TrustNumberField,
  ConfirmDangerModalComponent,
  IDType,
  OneColumn,
  IDTypeSelectComponent,
  MenuItemsForDropDown,
  CompanyRegNoField,
} from "@soqs/common"; 
import ResidentialAddress from "../Address/ResidentialAddressComponent";
import PostalAddress from "../Address/PostalAddressComponent";
import SelectComponent from "../Helpers/UserComponents/SelectComponent";
import { Form, FormSpy } from "react-final-form";
import DateSelectorComponent from "../Helpers/UserComponents/DateSelectorComponent";
import {
  updateFormState,
  formState,
  dropdownoptions,
  dropdownsloading,
  cancelVerification, 
  isLoading,
  isPrepop,
  submitFormRegAsync,
} from "../../features/trnAppSlice";
import PhoneFieldComponent from "../Helpers/UserComponents/PhoneFieldComponent";
import { PAGES } from "../../App";
import { config } from "../../config";

export default function RegisterForTaxNumberForm() {
  
  const urlPath = window.location.href;
  const dispatch = useDispatch();
  const dropdownopts = useSelector(dropdownoptions);
  const dropdownoptsloading = useSelector(dropdownsloading);
  const reduxFormState = useSelector(formState);
  const loading = useSelector(isLoading);
  const prepop = useSelector(isPrepop);

  // Clean Internal Form State
  const initialState = {
    IDType: IDType.RSA_Id,

    //testing
    // pitRegMobileNumber: "0823384475",
    // pitRegPhysicalAddressCountry: "ZA",
    // pitRegPostalAddressCountry: "ZA",
    // pitRegFirstName: "Tester",
    // pitRegSurname: "Testing",
    // pitRegIdNumber: "3407295023083",
    // pitRegMaritalStatus: "0",
    // pitRegPhysicalAddressStreetNumber: "1",
    // pitRegPhysicalAddressStreetName: "street",
    // pitRegPhysicalAddressSuburb: "Sub",
    // pitRegPhysicalAddressCity: "Cape",
    // pitRegPhysicalAddressCode: "7140",
  };

  const prefilledState = useMemo(
    () => reduxFormState?.values ?? initialState,
    []
  );

  //Users provide either Mobile or/and Email continue
  const requireContactDetails = () => {
    // Input is empty
    alert("Please enter your Mobile Number or Email Address!");
    return;
  };

  // Internal State
  const [confirmClearModal, setConfirmClearModal] = useState(false);
  const handleSubmit = async () => {
    await dispatch(submitFormRegAsync());
  };
 

 const extractDOBFromID = (idNumber) => {
    if (idNumber && idNumber.length >= 6) {
      const year = idNumber.slice(0, 2);
      const month = idNumber.slice(2, 4);
      const day = idNumber.slice(4, 6);

      const currentYear = new Date().getFullYear() % 100;
      const fullYear =
        parseInt(year, 10) > currentYear ? `19${year}` : `20${year}`;

      return new Date(
        parseInt(fullYear, 10),
        parseInt(month, 10) - 1,
        parseInt(day, 10)
      ).toLocaleDateString("en-za");
    }
    return null;
  };

  const setDOBFromID = useMemo(
    () =>
      createDecorator({
        field: "pitRegIdNumber",
        updates: {
          pitRegDOB: (idNumber) => { 
             return extractDOBFromID(idNumber);
          },
        },
      }),
    []
  );

  return (
    <>
      <Grid size={{ xs: 12}}>
        <Form
          onSubmit={handleSubmit}
          initialValues={prefilledState}
          decorators={[setDOBFromID]}
        >
          {({ handleSubmit, values  }) => (
            <>
              <FormSpy
                onChange={(state) => {
                  dispatch(updateFormState(state));
                }}
              />
              <Card>
                <CardHeader title="My Personal Details:" />
                <CardContent>
                  <Grid container columnSpacing={1.5} rowSpacing={0.5}>
                    <OneColumn>
                      <IDTypeSelectComponent
                        name="IDType"
                        options={MenuItemsForDropDown(
                          "idtype",
                          dropdownopts,
                          true
                        )}
                        optionsloading={dropdownoptsloading}
                        disabled={true}
                      />
                    </OneColumn>
                    <OneColumn>
                      {values?.IDType === IDType.RSA_Id ? (
                        <IDNumberComponent
                          disabled={prepop?.pitRegIdNumber}
                          name="pitRegIdNumber"
                        />
                      ) : values?.IDType === IDType.Passport ? (
                        <PassportComponent
                          disabled={prepop?.pitRegIdNumber}
                          name="pitRegIdNumber"
                        />
                      ) : values?.IDType ===
                        IDType.CompanyRegistrationNumber ? (
                        <CompanyRegNoField disabled={prepop} />
                      ) : values?.IDType === IDType.TrustNumber ? (
                        <TrustNumberField
                          disabled={prepop?.pitRegIdNumber}
                          name="pitRegIdNumber"
                        />
                      ) : (
                        <IDNumberComponent
                          disabled={prepop?.pitRegIdNumber}
                          name="pitRegIdNumber"
                        />
                      )}
                    </OneColumn>
                    <OneColumn>
                      <NameField
                        aria-label="Name"
                        name="pitRegFirstName"
                        disabled={prepop?.pitRegFirstName}
                      />
                    </OneColumn>
                    <OneColumn>
                      <SurnameField
                        aria-label="Surname"
                        name="pitRegSurname"
                        disabled={prepop?.pitRegSurname}
                      />
                    </OneColumn>
                    <OneColumn>
                      <DateSelectorComponent
                        aria-label="Date of Birth"
                        name="pitRegDOB"
                        label="Date of Birth"
                        disabled
                        maxdate={new Date()}
                      />
                    </OneColumn>
                    <OneColumn>
                      <SelectComponent
                        aria-label="Marital Status"
                        name="pitRegMaritalStatus"
                        label="Marital Status"
                        options={MenuItemsForDropDown(
                          "maritalStatus",
                          dropdownopts,
                          false
                        )}
                        optionsloading={dropdownoptsloading}
                        required
                      />
                    </OneColumn>
                  </Grid>
                </CardContent>
              </Card>

              <Card>
                <CardHeader title="My Communication Details:" />
                <CardContent>
                  <Grid container columnSpacing={1.5} rowSpacing={0.5}>
                    {/* <OneColumn>
                      <MobileNumberField name="pitRegMobileNumber" />
                    </OneColumn>
                    <OneColumn>
                      <EmailField name="pitRegEmailAddress" required={false} />
                    </OneColumn> */}

                    <OneColumn>
                      <PhoneFieldComponent
                        aria-label="Mobile Number"
                        name="pitRegMobileNumber"
                        required={!values.pitRegEmailAddress}
                        checkEmail={true}
                      />
                    </OneColumn>
                    <OneColumn>
                      <EmailAddressTRN
                        aria-label="Email address"
                        name="pitRegEmailAddress"
                        required={!values.pitRegMobileNumber}
                        checkMobile={false}
                      />
                    </OneColumn>
                  </Grid>
                </CardContent>
              </Card>
              <ResidentialAddress aria-label="My Residential Address" />
              <PostalAddress aria-label="My Residential Address" />
              <Card>
                <CardContent>
                  <Grid container columnSpacing={1.5} rowSpacing={0.5}>
                    <Grid size={{ xs: 12}}>
                      <Grid container justifyContent="space-between">
                        <Grid>
                          <Button
                            aria-label="Reset Button"
                            type="button"
                            variant="outlined"
                            onClick={() => {
                              setConfirmClearModal(true);
                            }}
                          >
                            Reset
                          </Button>
                        </Grid>
                        <Grid>
                          <Button
                            aria-label="Submit Button"
                            loading={loading}
                            type="submit"
                            variant="contained"
                            onClick={
                              values?.email === "" && values?.mobile === ""
                                ? requireContactDetails
                                : handleSubmit
                            }
                          >
                            Submit
                          </Button>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
              <ConfirmDangerModalComponent
                open={confirmClearModal}
                onClose={() => {
                  setConfirmClearModal(false);
                }}
                cbConfirm={() => {
                  // form.restart(initialState);
                  // setConfirmClearModal(false);
                  window.location.reload(false);
                  dispatch(
                    cancelVerification({
                      targetPage: urlPath.includes("pitregistration")
                        ? PAGES.RegisterForTaxNumberForm
                        : PAGES.WhatsMyTaxNumberForm,
                    })
                  );
                }}
                title="Reset form"
                subheader="Are you sure you want to clear the form?"
                confirmText="Clear"
              />
              {["development"].includes(
                config.ENVIRONMENT
              ) ? (
                <pre>{JSON.stringify(values, null, 2)}</pre>
              ) : (
                <></>
              )}
            </>
          )}
        </Form>
      </Grid>
    </>
  );
}
